import { useObservable } from '@lib/common';
import { Manager, vipHousekeepingOverrideQuery, vipHousekeepingOverrideService } from '@lib/state';
import { employeeQuery, employeeService } from 'app/state';
import { useEffect } from 'react';

export function useVipHousekeepingOverride(propertyId: string) {
  useEffect(() => {
    vipHousekeepingOverrideService.getVipOverrides(propertyId);
  }, [propertyId]);

  return {
    overrides: useObservable(vipHousekeepingOverrideQuery.vipHousekeepingOverrides),
    loading: useObservable(vipHousekeepingOverrideQuery.loading),
  };
}

export function useManagers(propertyId: string | null) {
  const managers = useObservable(employeeQuery.employees);
  const loading = useObservable(employeeQuery.loading);

  useEffect(() => {
    if (propertyId) {
      employeeService.getEmployees({ propertyId, roles: [Manager] });
    }
  }, [propertyId]);

  return {
    managers,
    loading,
  };
}
